import React, { useEffect, useRef } from 'react';
import { GrFormPrevious } from "react-icons/gr"
import { GrFormNext } from "react-icons/gr"
import { useNavigate } from 'react-router-dom';
import Swiper from 'swiper/bundle';
import img1 from "../assets/carousel-img1.webp"
import img2 from "../assets/carousel-img2.webp"
import img3 from "../assets/carousel-img3.webp"
import '../App.css';


const Carousel = () => {
  const swiperRef = useRef(null);

  useEffect(() => {
    const swiper = new Swiper('.swiper-container.two', {
      pagination: '.swiper-pagination',
      paginationClickable: true,
      effect: 'coverflow',
      centeredSlides: true,
      slidesPerView: '4',
      initialSlide: '1',
      coverflow: {
        rotate: 0,
        stretch: 100,
        depth: 150,
        modifier: 1.5,
        slideShadows: false,
      },
      navigation: {
        prevEl: '.swiper-button-prev',
        nextEl: '.swiper-button-next',
      },
    });

    swiperRef.current = swiper;
  }, []);

  const getCurrentSlideNumber = () => {
    if (swiperRef.current) {
      return console.log(swiperRef.current.activeIndex + 1)
    }
    return null;
  };

  const navigate =  useNavigate()

  const handleClick = (data) =>{
    localStorage.setItem('nav',data)
    window.scrollTo(0,700)
    navigate("/project")
  }

  return (
    <div id="main">
      <div style={{width:"80%" ,overflow:"hidden"}} className="swiper-container two">
        <div className="swiper-wrapper">
          <div className="swiper-slide">
            <div className="slider-image">
             
             <img
             style={{cursor:"pointer"}}
             onClick={()=> handleClick("CAR")}
                src={img2}
                alt='vwrap'
              />
              <p>
                <p>ON VEHICLE ADVERTISEMENT PLATFORM PROVIDER</p>
                <span>Vwrap takes brands street to street to cover every possible corner of the city so it’s message is seen</span>
              </p>
            </div>
          </div>
          <div className="swiper-slide">
            <div className="slider-image">
             
             <img
             style={{cursor:"pointer"}}
             onClick={()=> handleClick("ALL")}
                src={img1}
                alt='vwrap'
              />
              <p className='bg-none'>
                <p className='color-theme'>360 ADVERTISEMENT PLANING</p>
                <span>360°Marketing Campaign is a complete creative campaign idea across allthe brand’s marketing</span>
              </p>

            </div>
          </div>
          <div className="swiper-slide">
            <div className="slider-image">
             
             <img
             
             style={{cursor:"pointer"}}
             onClick={()=> handleClick("BILLBOARDS")}
                src={img3}
                alt='vwrap'
              />
              <p className='bg-none'>
                <p className='color-theme'>OUT OF HOME ADVERTISEMENT PLATFORM PROVIDER</p>
                <span>Vwrap is a promising advertisement agency, established with an aim to provide effective quality out of home</span>
              </p>
             
            </div>
          </div>
        </div>
        <div className="swiper-pagination"></div>
        <div className="swiper-button-prev"><GrFormPrevious /></div>
        <div className="swiper-button-next"><GrFormNext /></div>
      </div>
    </div>
  );
};

export default Carousel;
